import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';

interface DialogData {

}

@Component({
  selector: 'app-reject-live-rfq',
  templateUrl: './reject-live-rfq.component.html',
  styleUrls: ['./reject-live-rfq.component.scss']
})
export class RejectLiveRfqComponent implements OnInit {

  rowData;
  reasonList: [];
 
  rejectionId;
  otherReasons: boolean;
  inputOtherReason;
  enquiryId;
  action: any;

  constructor(public dialogref: MatDialogRef<RejectLiveRfqComponent>,
    private adminSerive: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private router:Router,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.rowData = this.data["data"]
    this.enquiryId = this.rowData.id
    this.action = this.rowData['action']
    console.log(this.enquiryId)
    this.getrejectionList();    
    this.toastr.info('You are rejecting an Enquiry', 'info')

  }

  getrejectionList() {
    this.adminSerive.getRejectReasonList().subscribe(
      (res: any) => {
        console.log(res.body)
        this.reasonList = res.body;
      }
    )
  }

  close() {
    this.dialogref.close()
  }

  radioChange(event) {
    let details: any = this.reasonList[parseInt(event.value)];
    this.rejectionId = details.id;
    if (this.rejectionId == 7) {
      console.log(true)
      this.otherReasons = false;
    }
    else {
      this.otherReasons = true;
    }
  }

  inputField(event) {
    console.log(event)
    this.inputOtherReason = event
  }


  submit() {
    if (this.rejectionId !== 7) {
      this.inputOtherReason = ""
    }

    let form = {
      "vendor_order": {
        "rejection_note": this.inputOtherReason,
        "vendor_order_rejection_reasons_attributes": [{
          "rejection_reason_id": this.rejectionId,
        }]
      }
    }

    console.log(form)

    if(this.action === 'revision-accept'){
      this.adminSerive.acceptRevisedLiveEnquiry(this.enquiryId, form).subscribe(
        res => {
          this.toastr.success(`you have accepted revised enquiry with code ${this.rowData.order_code}`, 'success');
          this.toastr.success(`you can proceed to submit quote for the enquiry now`, 'success');
          this.close();
          this.router.navigate(['/admin/rfq'])
        },
        err => {
          this.toastr.error('Something Went wrong', 'Error');
          this.close();
        }
      )
    }
    else if(this.action === 'revision-reject'){
      this.adminSerive.rejectRevisedLiveEnquiry(this.enquiryId, form).subscribe(
        res => {
          this.toastr.success(`you have rejected revised enquiry with code ${this.rowData.order_code}`, 'success');
          this.toastr.success(`you can proceed to submit quote for the original enquiry now`, 'success');
          this.close();
          this.router.navigate(['/admin/rfq'])
        },
        err => {
          this.toastr.error('Something Went wrong', 'Error');
          this.close();
        }
      )
    }
    else{
      this.adminSerive.rejectLiveEnquiry(this.enquiryId, form).subscribe(
        res => {
          this.toastr.success(`Your Enquiry with ${this.rowData.order_code} is rejected`, 'success');
          this.close();
          this.router.navigate(['/admin/rfq'])
        },
        err => {
          this.toastr.error('Something Went wrong', 'Error');
          this.close();
        }
      )
    }
  }



}
